
// @ts-nocheck
import locale_de_46json_5c5d9b29 from "#nuxt-i18n/5c5d9b29";
import locale_en_46json_2f3fc6f3 from "#nuxt-i18n/2f3fc6f3";
import locale_fr_46json_f30330dc from "#nuxt-i18n/f30330dc";
import locale_nl_46json_4770c7c9 from "#nuxt-i18n/4770c7c9";
import locale_da_46json_4aec0a26 from "#nuxt-i18n/4aec0a26";
import locale_hu_46json_9f42ed67 from "#nuxt-i18n/9f42ed67";
import locale_it_46json_cc477b31 from "#nuxt-i18n/cc477b31";
import locale_es_46json_ea3b4e59 from "#nuxt-i18n/ea3b4e59";

export const localeCodes =  [
  "de",
  "en",
  "fr",
  "nl",
  "da",
  "hu",
  "it",
  "es"
]

export const localeLoaders = {
  de: [
    {
      key: "locale_de_46json_5c5d9b29",
      load: () => Promise.resolve(locale_de_46json_5c5d9b29),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_2f3fc6f3",
      load: () => Promise.resolve(locale_en_46json_2f3fc6f3),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_f30330dc",
      load: () => Promise.resolve(locale_fr_46json_f30330dc),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_nl_46json_4770c7c9",
      load: () => Promise.resolve(locale_nl_46json_4770c7c9),
      cache: true
    }
  ],
  da: [
    {
      key: "locale_da_46json_4aec0a26",
      load: () => Promise.resolve(locale_da_46json_4aec0a26),
      cache: true
    }
  ],
  hu: [
    {
      key: "locale_hu_46json_9f42ed67",
      load: () => Promise.resolve(locale_hu_46json_9f42ed67),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_46json_cc477b31",
      load: () => Promise.resolve(locale_it_46json_cc477b31),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_ea3b4e59",
      load: () => Promise.resolve(locale_es_46json_ea3b4e59),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "de",
      iso: "de-DE",
      files: [
        {
          path: "/app/locales/de.json",
          cache: undefined
        }
      ]
    },
    {
      code: "en",
      iso: "en-US",
      files: [
        {
          path: "/app/locales/en.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fr",
      iso: "fr-FR",
      files: [
        {
          path: "/app/locales/fr.json",
          cache: undefined
        }
      ]
    },
    {
      code: "nl",
      iso: "nl-NL",
      files: [
        {
          path: "/app/locales/nl.json",
          cache: undefined
        }
      ]
    },
    {
      code: "da",
      iso: "da-DK",
      files: [
        {
          path: "/app/locales/da.json",
          cache: undefined
        }
      ]
    },
    {
      code: "hu",
      iso: "hu-HU",
      files: [
        {
          path: "/app/locales/hu.json",
          cache: undefined
        }
      ]
    },
    {
      code: "it",
      iso: "it-IT",
      files: [
        {
          path: "/app/locales/it.json",
          cache: undefined
        }
      ]
    },
    {
      code: "es",
      iso: "es-ES",
      files: [
        {
          path: "/app/locales/es.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "de",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: false,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: true,
    cookieCrossOrigin: true,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: true,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "de",
    iso: "de-DE",
    files: [
      {
        path: "/app/locales/de.json",
        cache: undefined
      }
    ]
  },
  {
    code: "en",
    iso: "en-US",
    files: [
      {
        path: "/app/locales/en.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fr",
    iso: "fr-FR",
    files: [
      {
        path: "/app/locales/fr.json",
        cache: undefined
      }
    ]
  },
  {
    code: "nl",
    iso: "nl-NL",
    files: [
      {
        path: "/app/locales/nl.json",
        cache: undefined
      }
    ]
  },
  {
    code: "da",
    iso: "da-DK",
    files: [
      {
        path: "/app/locales/da.json",
        cache: undefined
      }
    ]
  },
  {
    code: "hu",
    iso: "hu-HU",
    files: [
      {
        path: "/app/locales/hu.json",
        cache: undefined
      }
    ]
  },
  {
    code: "it",
    iso: "it-IT",
    files: [
      {
        path: "/app/locales/it.json",
        cache: undefined
      }
    ]
  },
  {
    code: "es",
    iso: "es-ES",
    files: [
      {
        path: "/app/locales/es.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = true
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/